import axios from "axios";
import { Promise } from "q";
import { API_URL, STATUS_OK } from "./../../../../../config";

export default class AcceptShareModalService {
    static respondShare = (id, accepted, username, token) => {
        return new Promise((resolve, reject) => {
            axios
                .patch(
                    `${API_URL}users/${username}/notifications/${id}`,
                    {
                        bookmarks_share: { is_accepted: accepted }
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                )
                .then(response => {
                    if (response.status === STATUS_OK) resolve(response.data);
                    else reject(response);
                })
                .catch(error => {
                    reject(error);
                });
        });
    };
}
